export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function objectSortByLabel(currentObj, nextObj) {
  let currentLabel = currentObj.label.toUpperCase();
  let nextLabel = nextObj.label.toUpperCase();
  return (currentLabel < nextLabel) ? -1 : (currentLabel > nextLabel) ? 1 : 0;
}
